export default __webpack_public_path__ + "static/media/backcover.0051dfb5.txt";